.mainContainer {
  width: 100%;
  margin: 0 auto;
}

.auxTimers {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem;
}
